import { type AutocompleteProps, createFilterOptions } from "@mui/material";
import type { PipelineRun } from "src/queries/pipelines/pipelineRuns.types";
import type { EnhancedRun, PitSelectorRun } from "./PitSelector.types";

export const SLOT_PROPS = {
  listbox: { sx: { maxHeight: 500 } }, // currently unused because a custom Listbox component is used for virtualization
  paper: {
    "data-test-id": "pit-selector-paper",
    sx: {
      width: "max-content",
      minWidth: "100%",
    },
  },
  renderInput: {
    TextField: {
      slotProps: {
        input: {
          sx: {
            fontSize: 12,
            pr: "0 !important", // "0" right-padding because the "clear" & "arrow" icons are hidden (to make space for the text)
          },
        },
      },
    },
  },
} as AutocompleteProps<EnhancedRun, false, false, false>["slotProps"];

// const MAX_PITS = 100;

export const filterOptions = createFilterOptions<EnhancedRun>({
  ignoreCase: true,
  matchFrom: "any",
  stringify: (opt: PitSelectorRun) =>
    [opt.app_pit, (opt as PipelineRun).last_run, opt.start_time]
      .filter(Boolean)
      .join(" "),
  // limit: MAX_PITS,
});

export const ITEM_SIZES = { sm: 26, md: 48.58 };
export const LISTBOX_PADDING = 8; // px
export const MAX_ROWS_COUNT = 12;

/**
 * Width (px) of the left-rail gutter carved out of each <li> when a
 * `slots.option.leftRail` component is provided. The rail (line stripe + per-row
 * circle) sits in this gutter, outside the <li>'s background — so MUI's
 * hover/selected/Mui-focused background colors don't paint over the rail.
 *
 * Single source of truth — bump this to give the rail more breathing room.
 */
export const LEFT_RAIL_GUTTER_PX = 16;
